import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PessoasJuridicasService } from "../pessoas-juridicas.service";
import { PessoaJuridica } from "src/app/model/pessoa-juridica.model";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import moment from "moment";
import { ExportPessoasJuridicasService } from "../export-pessoas-juridicas.service";

@Component({
    selector: 'app-pessoas-juridicas-pesquisa',
    templateUrl: './pessoas-juridicas-pesquisa.component.html',
    standalone: false
})
export class PessoasJuridicasPesquisaComponent implements OnInit {

  pesquisaForm: FormGroup;
  atributosPaginacaoComponenteListagem: EntityPagedResult<PessoaJuridica>;
  opcoesPaginacao: number[];
  msgSemResultado: boolean = false;
  pessoasJuridicas: PessoaJuridica[];
  dataHoraResultado: string;
  nomes: string[] = [];
  siglas: string[] = [];

  constructor(
    formBuilder: FormBuilder,
    private pessoasJuridicasService: PessoasJuridicasService,
    private exportPessoasJuridicasService: ExportPessoasJuridicasService,
    private bnLoadingService: BnLoadingService,
  ) {
    this.pesquisaForm = formBuilder.group({
      nome: null,
      sigla: null,
      cnpj: null
    });
  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.construirFormulario();
    this.carregarNomes();
    this.carregarSiglas();
  }

  async carregarNomes() {
    this.nomes = await this.pessoasJuridicasService.buscarNomes().toPromise();
  }

  async carregarSiglas() {
    this.siglas = await this.pessoasJuridicasService.buscarSiglas().toPromise();
  }

  private construirFormulario() {
    const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaPessoasJuridicasForm'));
    if (valoresPesquisaForm) {
      this.pesquisaForm.setValue({
        nome: valoresPesquisaForm.nome,
        sigla: valoresPesquisaForm.sigla,
        cnpj: valoresPesquisaForm.cnpj,
      });
    }
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      sessionStorage.setItem('valoresPesquisaPessoasJuridicasForm', JSON.stringify(novosValores));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<PessoaJuridica>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(true);
}

  limpar() {
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.pesquisaForm.reset();
    this.pessoasJuridicas = [];
    this.msgSemResultado = false;
  }

  async buscar(paginado: boolean){
    this.bnLoadingService.bloqueiaTela();
    const pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    const limite = this.atributosPaginacaoComponenteListagem.pageSize;
    const dadosPreenchidos = { ...this.pesquisaForm.value, pagina, limite };
    const response = await this.pessoasJuridicasService.buscar(dadosPreenchidos).toPromise();
    this.pessoasJuridicas = response ? response.resultados : null;
    this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
    this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
    this.bnLoadingService.liberaTela();
  }

  async exportarPessoasJuridicas() {
    this.bnLoadingService.bloqueiaTela();
    try {
      const dadosPreenchidos = this.pesquisaForm.value;
      const resp = await this.pessoasJuridicasService.buscar(dadosPreenchidos).toPromise();
      this.exportPessoasJuridicasService.exportarPessoasJuridicas(resp);
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

}
